export default {"src":"/_next/static/media/paper-plane.725ef647.svg","height":220,"width":284,"blurWidth":0,"blurHeight":0};